import { TenantJob } from '~/tenants/common/TenantJob';
import { MlmOrderContext, MlmOrderType, MlmPerformableConfig } from '~/tenants/mlm/model/MlmOrder';

export default abstract class MlmJob<P extends MlmPerformableConfig = MlmPerformableConfig> extends TenantJob<
  MlmOrderContext,
  P
> {
  get eligible() {
    return this.order.metadata.type !== MlmOrderType.COMMERCIAL;
  }
}
